import React from 'react';

const HireTable = () => {
    const tableData = [
        { label: "Number of BIM Revit Modelers", inHouse: "1", ourService: "1" },
        { label: "Infrastructure cost", inHouse: "$ 1000", ourService: "$ 0" },
        { label: "Salary", inHouse: "$ 5000 - $ 6000", ourService: "$ 2000 - $ 2800" },
        { label: "Insurance", inHouse: "$ 300", ourService: "$ 0" },
        { label: "Software cost", inHouse: "$ 500", ourService: "$ 0" },
        { label: "Training", inHouse: "$ 200", ourService: "$ 0" },
        { label: "Scaling up or down of team as per projects", inHouse: "Costly & Risky", ourService: "No risk, pay only for the time utilized" },
        { label: "Total", inHouse: "$ 7000 - $ 8000", ourService: "$ 1900 - $ 2800 (Including Project Management)", isTotal: true },
    ];

    return (
        <section className="hire-table-section">
            <div className="hire-table-container">
                <div className="comparison-table-wrapper">
                    <div className="comparison-table">
                        {/* Header Row */}
                        <div className="table-row table-header">
                            <div className="table-cell empty-cell"></div>
                            <div className="table-cell header-cell">In-house / Month</div>
                            <div className="table-cell header-cell">From Our Services / Month</div>
                        </div>

                        {/* Data Rows */}
                        {tableData.map((row, index) => (
                            <div key={index} className={`table-row ${row.isTotal ? 'total-row' : ''}`}>
                                <div className="table-cell label-cell">{row.label}</div>
                                <div className="table-cell data-cell">{row.inHouse}</div>
                                <div className="table-cell data-cell highlight-cell">{row.ourService}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HireTable;
